import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { USUARIOS_NUEVO, USUARIOS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function UsuariosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${USUARIOS_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${USUARIOS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${USUARIOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
